import { AccountInformationData } from "../commponent/AccountInformation/AccountInformation.data";
import { BusinessActivityData } from "../commponent/BusinessActivity/BusinessActivity.data";
import { CorporateInformationData } from "../commponent/CorporateInformation/CorporateInformation.data";
import { EditEmployeeFormData, NewEmployeeFormData } from "../commponent/EmployeesList/data/NewEmployeeData";
import { AddKeypositionData } from "../commponent/MemberkeyPositions/KeyPositions.data";
import { MembershipSubscriptionData } from "../commponent/MembershipSubscription/MembershipSubscription.data";
import { OtherInformationData } from "../commponent/OtherInformation/OtherInformation.data";


export const setAllDropDownFieldForViewMember = (apiResponse) => {
    if (!Array.isArray(apiResponse) || apiResponse.length === 0) {
        return;
    }
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                    isDisabled: item?.isDisabled || false,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        // account info
        "membershipStatus": filterDropDownList("Tasklist Membership Status"),
        "membershipType": filterDropDownList("Membership Type"),
        "discontinuedReason": filterDropDownList("Discontinue Reason"),
        // membership sub
        "subscriptionType": filterDropDownList("Subscription Type"),
        "billingCategory": filterDropDownList("Billing Category"),
        "applicationType": filterDropDownList("Application Type"),
        "linkedMember": filterDropDownList("Linked Member Account"),
        "applicationTerm": filterDropDownList("Application Terms"),
        // Corporate Information
        "typeofCompany": filterDropDownList("Type Of Company"),
        "organisationProfile": filterDropDownList("Organisation Profile"),
        "businessCategories": filterDropDownList("Business Category"),
        "country": filterDropDownList("Country"),
        "businessAddressCountry": filterDropDownList("Country"),
        "mailAddressCountry": filterDropDownList("Country"),
        "billingAddressCountry": filterDropDownList("Country"),
        "mainPhoneNumber": filterDropDownList("Country Code"),
        "billingContactNumber": filterDropDownList("Country Code"),
        "billingName": filterDropDownList("Salutation"),
        "billingNumber": filterDropDownList("Country Code"),
        "pspcListedOrganisation": filterDropDownList("PSPC Org"),
        // Business Activity
        "organisationCategory": filterDropDownList("Org Category"),
        // "productsandServicesOfferedbyOrganisation": filterDropDownList("Product And Service"),
        "annualTurnover": filterDropDownList("Annual TurnOver"),
        "numberofEmployees": filterDropDownList("Number Of Employee"),
        // Other Information
        "howDidYouLearnSGBCId": filterDropDownList("Learn About SGBC"),
        "reasonOfJoining": filterDropDownList("Reason Of Joining"),
        // Key Positions
        "jobLevelId": filterDropDownList("Job Level"),
        "jobFunctionId": filterDropDownList("Job Function"),
        "salutationId": filterDropDownList("Salutation"),
        "mobileNumberCountryId": filterDropDownList("Country Code"),
        "contactNumberCountryId": filterDropDownList("Country Code"),
        "corporateRoleId": filterDropDownList("Role with limit"),
        // Employee
        "contactNumber": filterDropDownList("Country Code"),
    };

    const formFields = [...AccountInformationData.formFields, ...MembershipSubscriptionData.formFields, ...CorporateInformationData.formFields, ...BusinessActivityData.formFields, ...OtherInformationData.formFields, ...AddKeypositionData.formFields, , ...NewEmployeeFormData.formFields, , ...EditEmployeeFormData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList && dropdownList.length > 0 && field?.fieldSetting) {
            field.fieldSetting.options = dropdownList;
        }
    });
};

let defaultCss = "col-lg-6 col-12 mb-3";
let hiddenCss = "col-lg-6 col-12 mb-3 d-none";

export const hidePSPCFields = (formData) => {
    const toggleFieldIds = [
        "pspcListedOrganisation",
    ];
    return {
        ...formData,
        formFields: formData.formFields.map((field) =>
            toggleFieldIds.includes(field.id)
                ? {
                    ...field,
                    style: { ...field.style, containerCss: hiddenCss },
                    validation: [],
                }
                : field
        ),
    };
};
export const showPSPCFields = (formData) => {
    const toggleFieldIds = [
        "pspcListedOrganisation",
    ];
    return {
        ...formData,
        formFields: formData.formFields.map((field) =>
            toggleFieldIds.includes(field.id)
                ? {
                    ...field,
                    style: { ...field.style, containerCss: defaultCss },
                    validation: [{ type: "require" }],
                }
                : field
        ),
    };
};
export const hideGovernmentAgencyFields = (formData) => {
    const toggleFieldIds = [
        "nameofMinistry",
        "department",
        "businessUnit",
        "billingName",
        "billingNumber",
        "applicantRepresentativeDetails"
    ];
    return {
        ...formData,
        formFields: formData.formFields.map((field) =>
            toggleFieldIds.includes(field.id)
                ? {
                    ...field,
                    style: { ...field.style, containerCss: hiddenCss },
                    validation: [],
                }
                : field
        ),
    };
};
export const showGovernmentAgencyFields = (formData) => {
    const toggleFieldIds = [
        "nameofMinistry",
        "department",
        "businessUnit",
        "billingName",
        "billingNumber",
        "applicantRepresentativeDetails"
    ];
    return {
        ...formData,
        formFields: formData.formFields.map((field) =>
            toggleFieldIds.includes(field.id)
                ? {
                    ...field,
                    style: { ...field.style, containerCss: defaultCss },
                    validation: [{ type: "require" }],
                }
                : field
        ),
    };
};